import React from "react";
import Headings from "../../../constants/headings";
import Constants from "../../../constants/constants";
import { Row, Col, ListGroup } from "react-bootstrap";
import { ToPersianNumber, DateToPersianNumber } from "../../../functions/index";
function Trial(props) {
  return (
    <>
      <h2>{Headings.CurrentPeriod}</h2>
      <Row>
        <Col>
          <ListGroup>
            <ListGroup.Item>
              <b>
                {Constants.CurrentPeriodArray[0]}:&nbsp;
                <small>
                  {props.CurrentPeriodStartDate
                    ? DateToPersianNumber(props.CurrentPeriodStartDate)
                    : ""}
                </small>
              </b>
              <b>
                {Constants.CurrentPeriodArray[1]}:&nbsp;
                {props.CurrentPeriodUsageInfo
                  ? ToPersianNumber(props.CurrentPeriodUsageInfo.UsedMinutes.toString())
                  : ""}
                {/* {props.CurrentPeriodUsageInfo && ":"}
                {props.CurrentPeriodUsageInfo
                  ? ToPersianNumber(props.CurrentPeriodUsageInfo.UsedSeconds.toString())
                  : ""} */}
              </b>
              <b>
                {Constants.CurrentPeriodArray[2]}:&nbsp;
                {props.CurrentPeriodUsageInfo
                  ? ToPersianNumber(props.CurrentPeriodUsageInfo.OverMinutes.toString())
                  : ""}
              </b>
            </ListGroup.Item>
            <ListGroup.Item>
              <b>
                {Constants.CurrentPeriodArray[3]}:&nbsp;
                <small>
                  {props.CurrentPeriodEndDate
                    ? DateToPersianNumber(props.CurrentPeriodEndDate)
                    : ""}
                </small>
              </b>
              <b>
                {Constants.CurrentPeriodArray[4]}:&nbsp;
                {props.CurrentPeriodUsageInfo
                  ? ToPersianNumber(
                      props.CurrentPeriodUsageInfo.RemainingMinutes.toString()
                    )
                  : ""}
              </b>
              <b>
                {Constants.CurrentPeriodArray[5]}:&nbsp;
                {props.CurrentPeriodUsageInfo
                  ? ToPersianNumber(
                      props.CurrentPeriodUsageInfo.OverMinutesCost.toString()
                    )
                  : ""}
              </b>
            </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
    </>
  );
}
export default Trial;
